"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.to-string");
require("core-js/modules/es7.string.pad-start");
require("core-js/modules/es6.array.find-index");
require("core-js/modules/es6.set");
require("core-js/modules/es6.string.iterator");
require("core-js/modules/es6.array.from");
require("core-js/modules/es6.array.find");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
require("core-js/modules/es6.number.constructor");
var _taskConfig = require("@/api/taskConfig/taskConfig.js");
var _customerCoupon = require("@/api/activity/customerCoupon.js");
var _couponCode = _interopRequireDefault(require("@/api/activity/couponCode.js"));
var _couponExpand = require("@/api/activity/couponExpand");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'couponRuleAdd',
  emits: ['saved'],
  props: {
    ruleId: {
      type: String,
      default: ''
    }
  },
  watch: {
    ruleId: {
      immediate: true,
      handler: function handler(newId, oldId) {
        this.getShopList();
        // 避免初始化时的不必要调用
        if (newId && newId != '' && newId != 'null') {
          this.handleEdit(newId);
        }
        ;
        console.log('actId', newId);
      }
    },
    // 当切换“全部门店”时，自动全选或清空所有门店
    isNationWide: function isNationWide(val) {
      // 若希望切换到“选择门店”时保留之前选中，可注释下一行
      this.checkedCities = [];
      this.selectedShops = [];
      this.allCodeNum = Number(this.form.couponCount) || 0;
    }
  },
  data: function data() {
    return {
      allCodeNum: 0,
      checkedCities: [],
      shoplist: [],
      isNationWide: 0,
      // 新增：真正保存已选门店的对象数组（包含 id、name、num 等）
      selectedShops: [],
      resPath: process.env.VUE_APP_IMAGE_PATH,
      loading: false,
      // 控制 v-loading 显示隐藏

      form: {
        id: '',
        ruleName: '',
        couponId: '',
        defaultLimit: 120.00,
        effectiveLogic: 1,
        status: 0,
        shopIds: []
      },
      rules: {
        ruleName: [{
          required: true,
          message: '请输入规则名称',
          trigger: 'blur'
        }],
        couponId: [{
          required: true,
          message: '请输入券ID',
          trigger: 'blur'
        }],
        defaultLimit: [{
          required: true,
          message: '请输入默认额度',
          trigger: 'blur'
        }],
        couponName: [{
          required: true,
          message: '请选择券名称',
          trigger: 'change'
        }]
      },
      couponOptions1: [],
      couponLoading: false
    };
  },
  methods: {
    // 是否城市下所有门店已被选中
    isCityAllSelected: function isCityAllSelected(city) {
      var _this = this;
      if (!city || !city.dealerList || city.dealerList.length == 0) return false;
      return city.dealerList.every(function (s) {
        return _this.checkedCities.includes(s.dealerId);
      });
    },
    // 城市是否部分选中（用于 indeterminate）
    isCityIndeterminate: function isCityIndeterminate(city) {
      var _this2 = this;
      if (!city || !city.dealerList || city.dealerList.length === 0) return false;
      var selectedCount = city.dealerList.filter(function (s) {
        return _this2.checkedCities.includes(s.dealerId);
      }).length;
      return selectedCount > 0 && selectedCount < city.dealerList.length;
    },
    // 切换城市：checked 为布尔值，true 时加入该城市所有门店 id，false 时移除
    toggleCity: function toggleCity(city, checked) {
      var _this3 = this;
      var ids = (city.dealerList || []).map(function (s) {
        return s.dealerId;
      });
      if (checked) {
        city.dealerList.forEach(function (s) {
          // 保证数量有默认值
          if (!s.num || s.num === '') {
            s.num = _this3.form.couponCount;
          }
          // checkedCities 用于 UI 复选框组（去重）
          if (!_this3.checkedCities.includes(s.dealerId)) {
            _this3.checkedCities.push(s.dealerId);
          }
          // 推入原始对象引用（不要克隆），保持 num 的实时同步
          if (!_this3.selectedShops.find(function (x) {
            return x.dealerId === s.dealerId;
          })) {
            _this3.selectedShops.push(s);
          }
        });
        // 去重（保险）
        this.checkedCities = Array.from(new Set(this.checkedCities.concat(ids)));
      } else {
        city.dealerList.forEach(function (s) {
          s.num = '';
          var idx = _this3.selectedShops.findIndex(function (x) {
            return x.dealerId === s.dealerId;
          });
          if (idx > -1) _this3.selectedShops.splice(idx, 1);
        });
        this.checkedCities = this.checkedCities.filter(function (dealerId) {
          return !ids.includes(dealerId);
        });
      }
    },
    changeShop: function changeShop(shop, checked) {
      if (!checked) {
        shop.num = '';
        var idx = this.selectedShops.findIndex(function (x) {
          return x.dealerId === shop.dealerId;
        });
        if (idx > -1) this.selectedShops.splice(idx, 1);
        // 从checkedCities中移除
        var cityIdx = this.checkedCities.indexOf(shop.dealerId);
        if (cityIdx > -1) {
          this.checkedCities.splice(cityIdx, 1);
        }
      } else {
        if (!shop.num || shop.num === '') {
          shop.num = this.form.couponCount;
        }
        var exist = this.selectedShops.find(function (x) {
          return x.dealerId === shop.dealerId;
        });
        if (exist) {
          // 已保存的是同一引用（或同 id），更新数量
          exist.num = shop.num;
        } else {
          // 推入原始对象引用，保证 num 实时同步
          this.selectedShops.push(shop);
        }
        // 确保checkedCities中包含该门店ID
        if (!this.checkedCities.includes(shop.dealerId)) {
          this.checkedCities.push(shop.dealerId);
        }
      }
      ;
    },
    syncSelectedShopsFromCheckedCities: function syncSelectedShopsFromCheckedCities() {
      var _this4 = this;
      var selectedSet = new Set(this.checkedCities || []);
      this.selectedShops = [];
      this.shoplist.forEach(function (city) {
        (city.dealerList || []).forEach(function (shop) {
          if (selectedSet.has(shop.dealerId)) {
            if (!shop.num || shop.num === '') {
              shop.num = _this4.form.couponCount || 0;
            }
            _this4.selectedShops.push(shop);
          }
        });
      });
    },
    pad: function pad(n) {
      return n.toString().padStart(2, '0');
    },
    // 获取任务详细信息
    handleEdit: function handleEdit(id) {
      var _this5 = this;
      // 获取详情
      (0, _customerCoupon.getCouponRuleInfo)({
        id: id
      }).then(function (res) {
        if (res.code === 200) {
          _this5.form = _objectSpread({}, res.data);
          _this5.checkedCities = Array.isArray(_this5.form.shopIds) ? (0, _toConsumableArray2.default)(_this5.form.shopIds) : [];
          _this5.syncSelectedShopsFromCheckedCities();
          var promises = (0, _couponExpand.getCouponByThirdId)(_this5.form.couponId).then(function (response) {
            response.data.thirdCouponId = Number(response.data.thirdCouponId);
            // 不要赋值 push 的返回值，直接 push 到数组或返回数据由 Promise.all 统一赋值
            return response.data;
          }).catch(function (error) {
            console.error('获取失败:', error);
            return null;
          });
          Promise.all([promises]).then(function (results) {
            // 过滤掉失败的 null，然后整体替换 couponOptions1
            _this5.couponOptions1 = results.filter(function (r) {
              return r;
            });
            console.log('couponOptions12', _this5.couponOptions1);
          });
        } else {
          _this5.$message.error(res.msg || '获取详情失败');
        }
      }).catch(function (err) {
        _this5.$message.error('网络错误，请稍后重试');
      });
    },
    fetchCoupons1: function fetchCoupons1(query) {
      var _this6 = this;
      this.couponLoading = true;
      var params = {
        page: 1,
        limit: 9999,
        typeName: query || '' // ✅ 关键点：从输入框获取模糊搜索的关键字
      };
      (0, _taskConfig.getBonusTypes)(params).then(function (res) {
        var records = res.records || [];
        // 去重处理，避免重复的优惠券数据
        var uniqueRecords = records.filter(function (item, index, self) {
          if (!item || !item.thirdCouponId) return false;
          return index === self.findIndex(function (t) {
            return t.thirdCouponId === item.thirdCouponId;
          });
        });
        _this6.couponOptions1 = uniqueRecords;
      }).finally(function () {
        _this6.couponLoading = false;
      });
    },
    // 提交表单
    handleSubmit: function handleSubmit() {
      var _this7 = this;
      this.$refs.formRef.validate(function (valid) {
        if (valid) {
          _this7.loading = true;
          _this7.form.shopIds = _this7.checkedCities;
          // 新增或更新
          if (_this7.form.id) {
            (0, _customerCoupon.updCouponRule)(_this7.form).then(function (res) {
              if (res.code === 200) {
                _this7.$message.success('更新成功');
                _this7.dialogVisible = false;
                _this7.handleClose();
              } else {
                _this7.$message.error(res.msg || '更新失败');
              }
            }).catch(function (err) {
              _this7.$message.error('网络错误，请稍后重试');
            }).finally(function () {
              _this7.loading = false;
            });
          } else {
            (0, _customerCoupon.saveCouponRule)(_this7.form).then(function (res) {
              if (res.code === 200) {
                _this7.$message.success('新增成功');
                _this7.dialogVisible = false;
                _this7.handleClose();
              } else {
                _this7.$message.error(res.msg || '新增失败');
              }
            }).catch(function (err) {
              _this7.$message.error('网络错误，请稍后重试');
            }).finally(function () {
              _this7.loading = false;
            });
          }
        }
      });
    },
    handleClose: function handleClose() {
      this.$emit('saved'); // 通知父组件刷新列表
    },
    removeShop: function removeShop(shop) {
      this.selectedShops = this.selectedShops.filter(function (item) {
        return item.dealerId !== shop.dealerId;
      });
      this.checkedCities = this.checkedCities.filter(function (id) {
        return id !== shop.dealerId;
      });
      this.shoplist.forEach(function (city) {
        var dealer = (city.dealerList || []).find(function (d) {
          return d.dealerId === shop.dealerId;
        });
        if (dealer) {
          dealer.num = '';
        }
      });
    },
    getShopList: function getShopList() {
      var _this8 = this;
      _couponCode.default.getStoreList().then(function (res) {
        res.forEach(function (city) {
          city.dealerList = (city.dealerList || []).map(function (dealer) {
            return Object.assign({}, dealer, {
              num: '' // 初始化数量为空，保证 v-model="shop.num" 可用且响应式
            });
          });
        });
        _this8.shoplist = res;
        if (Array.isArray(_this8.checkedCities) && _this8.checkedCities.length > 0) {
          _this8.syncSelectedShopsFromCheckedCities();
        }
      });
    }
  }
};